import DOMPurify from 'dompurify';

/**
 * Sanitizes rich-text HTML (question/answer bodies authored via the Quill
 * editor) before it is bound with v-html. Never render professor/aluno
 * authored HTML without passing it through this first.
 */
export function sanitizeHtml(html) {
    if (!html) {
        return '';
    }
    return DOMPurify.sanitize(String(html));
}

export default sanitizeHtml;
